import { ReduxRootState, RootState } from 'model/Redux';
import { Selector } from 'react-redux';
import IWithdrawFeeStoreData from './IWithdrawFeeStoreData';

export const withdrawFeeSelector: Selector<RootState, ReduxRootState<IWithdrawFeeStoreData>> = state => state.withdrawFee;
export const withdrawFeeLoadingSelector: Selector<RootState, boolean> = state => state.withdrawFee.loading;
export const withdrawFeeDataSelector: Selector<RootState, IWithdrawFeeStoreData> = state => state.withdrawFee.data;
